import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/Card';
import { DashboardCardSkeleton } from './dashboardUi';

type KpiCardProps = {
  icon: LucideIcon;
  label: string;
  value: string | number;
  subtitle: string;
  loading?: boolean;
  accentClass?: string;
};

export function KpiCard({
  icon: Icon,
  label,
  value,
  subtitle,
  loading = false,
  accentClass = 'from-indigo-500 via-purple-500 to-pink-500',
}: KpiCardProps) {
  if (loading) {
    return <DashboardCardSkeleton variant="kpi" />;
  }

  return (
    <Card className="border-purple-200/60 dark:border-purple-500/25 bg-white dark:bg-gray-800 hover:shadow-md transition-shadow">
      <CardContent className="p-4 sm:p-5">
        <div
          className={`inline-flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br ${accentClass} text-white shadow-sm mb-3`}
        >
          <Icon className="h-4.5 w-4.5" aria-hidden />
        </div>
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
          {label}
        </p>
        <p className="mt-1 text-2xl font-black tabular-nums text-slate-900 dark:text-white">{value}</p>
        <p className="mt-1 text-xs text-slate-600 dark:text-slate-400 leading-snug">{subtitle}</p>
      </CardContent>
    </Card>
  );
}
